import { Grid,Typography } from '@mui/material';
import { FastField } from 'formik';
import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { CheckboxField } from '@shared/fields/CheckboxField';
import { TextInputField } from '@shared/fields/TextInputField';
import { IStipRequestForm } from '../StipRequestModal';

const leftPart  = (value: IStipRequestForm) =>  [
  {
    label: 'Borrower',
    type: 'label',
  },
  {
    name: 'contactEmail',
    label: 'Send Email',
    component: TextInputField,
    checkbox: true,
    checkboxName: 'checkContactEmail',
    disabled: !value?.['checkContactEmail'],
    disabledTextInput:true
  },
  {
    name: 'contactPhone',
    label: 'Text Message',
    component: TextInputField,
    checkbox: true,
    checkboxName: 'checkContactText',
    disabled: !value?.['checkContactText'],
    disabledTextInput:true
  },
];

const middlePart = (value: IStipRequestForm) => [
  {
    label: 'Co-Borrower',
    type: 'label',
  },
  {
    name: 'coBorrowerEmail',
    label: 'Send Email',
    component: TextInputField,
    width: '100%',
    checkbox: true,
    checkboxName: 'checkCoContactEmail',
    disabled: !value?.['checkCoContactEmail'],
    disabledTextInput:true
    },
  {
    name: 'coBorrowerPhone',
    label: 'Text Message',
    component: TextInputField,
    checkbox: true,
    checkboxName: 'checkCoContactText',
    disabled: !value?.['checkCoContactText'],
    disabledTextInput:true,
    
  }
];

const rightPart = [
  {
    label: 'Note',
    type: 'label',
  },
  {
    name: 'note',
    label: 'Note',
    bold: true,
    minRows: 3,
    multiline: true,
    component: TextInputField,
  },
];

const renderFields = <T extends object>(fieldsList: IFormFieldConfig<T>[]) =>
  fieldsList?.map(({ name, label, component: Component, checkboxName, type, checkbox, disabled,disabledTextInput, ...rest }) => (
    <Grid key={`${name}-${label}`} container mt={2}>
        <Grid item md={12}>
          {type === 'label' ? (
            <Typography variant="subtitle1">{label}</Typography>
          ) : (
            <Grid container>
              {!!checkbox && (
                <Grid item md={1}>
                  <FastField name={checkboxName}  component={CheckboxField} disabled = {disabled} {...rest} />
                </Grid>
              )}
              <Grid item md={11}>
                 <FastField label={label} name={name} component={Component} disabled ={disabledTextInput}  {...rest} width={'100%'} />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
  ));

  export const StipRequestForm = ({ value }: { value: IStipRequestForm }) => (
    <Grid container columnSpacing={12}>
      <Grid item md={4}>
        {renderFields(leftPart(value))}
      </Grid>
      <Grid item md={4}>
        {renderFields(middlePart(value))}
      </Grid>
      <Grid item md={4}>
        {renderFields(rightPart)}
      </Grid>
    </Grid>
);